export default function (initialDataInteractor) {
  return initialDataInteractor.data.questionnaire_instance_batches;
}